var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 8.34197 19.5965 6.77819 18.8823 5.4015C18.7327 5.11315 18.348 5.06624 18.1183 5.29594L10.4142 13C9.63317 13.781 8.36684 13.7811 7.58579 13L4.79289 10.2071C4.40237 9.81658 4.40237 9.18342 4.79289 8.79289C5.18342 8.40237 5.81658 8.40237 6.20711 8.79289L9 11.5858L17.0214 3.57007C17.211 3.38054 17.2183 3.07414 17.0276 2.88571C15.2215 1.10148 12.7394 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#2A85FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSvg);
export default __webpack_public_path__ + "static/media/Check_Svg.cda5d9b9a600ee5801e46113e1891633.svg";
export { ForwardRef as ReactComponent };